module.exports = __webpack_public_path__ + "img/Pending.43fc1f35.svg";